module.exports = __webpack_public_path__ + "static/media/default-user-avatar.051dd9ca.svg";